import type { ComponentProps } from 'react';

import type { PageGrid, PageGridItem } from 'corgi/common/components/PageGrid';

// Shared between PLP and Search
export const GRID_DEFAULT_STYLES: ComponentProps<typeof PageGrid> = {
  width: 1,
  maxWidth: 1600,
  alignItems: 'flex-start',
};

export const WITH_SHOP_IN_SHOP_GRID_STYLES: ComponentProps<typeof PageGrid> = {
  width: 1,
  px: ['sp_16', 'sp_24', 'sp_48', 'sp_64'],
  mx: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const GRID_GUTTER = ['sp_8', 'sp_12', null, 'sp_16'];

export const GRID_ITEM_STYLES: ComponentProps<typeof PageGridItem> = {
  px: ['sp_12', 'sp_0', 'sp_0', 'sp_0'],
  style: {
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: '9px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

// Shared between PLP and Search
export const SIDE_NAV_STYLES: ComponentProps<typeof PageGridItem> = {
  maxHeight: '100vh',
  overflowY: 'auto',
  position: 'sticky',
  top: 0,
  bg: 'sys.neutral.background.default',
  borderRadius: 'medium',
  padding: 'sp_16',
  pr: 'sp_24',
};

// Shared between PLP and Search
export const COLORED_BACKGROUND_STYLES: ComponentProps<typeof PageGrid> = {
  bg: 'sys.neutral.background.weak',
  pb: ['sp_16', 'sp_20', 'sp_24', 'sp_32'],
  px: ['sp_4', 'sp_8', 'sp_0', null],
  boxShadow: [
    'inset 0 8px 8px -8px rgba(0, 0, 0, 0.2), inset 0 -8px 8px -8px rgba(0, 0, 0, 0.2)',
    null,
    null,
    'inset 0 8px 8px -8px rgba(0, 0, 0, 0.2), inset 0 -8px 8px -8px rgba(0, 0, 0, 0.2)',
  ],
};

export const PROMOTED_FILTERS_TRANSITION_STYLES = {
  transition:
    'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
};

export const getPromotedFiltersTransformStyles = (showPromotedFilters: boolean) => ({
  ...PROMOTED_FILTERS_TRANSITION_STYLES,
  transform: showPromotedFilters ? 'translateY(0)' : 'translateY(-100%)',
  opacity: showPromotedFilters ? 1 : 0,
});

export const STICKY_HEADER_STYLES: ComponentProps<typeof PageGridItem> = {
  position: 'sticky',
  zIndex: 2,
};

export const PROMOTED_FILTERS_CONTAINER_STYLES: ComponentProps<typeof PageGridItem> = {
  maxWidth: 'none',
  backgroundColor: 'sys.neutral.background.hover',
  width: 1,
};

export const getPromotedFiltersContainerStyles = (showPromotedFilters: boolean) => ({
  ...PROMOTED_FILTERS_CONTAINER_STYLES,
  style: getPromotedFiltersTransformStyles(showPromotedFilters),
});

export const STICKY_BORDER_BOTTOM_STYLES = {
  boxShadow: 'inset 0 -2px 0 0 rgba(238, 238, 239, 1)',
};

export const getProductListLoadingStyles = (isLoading: boolean) => ({
  opacity: isLoading ? 0.5 : 1,
  transition: 'opacity 0.3s ease',
});
